/* eslint-disable max-len */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	department        : { initialCount: 0, data: [] },
	departments       : [],
	relations         : { page: 0, data: [] },
	designation       : { page: 0, data: [] },
	divisions         : { page: 0, data: [] },
	configuration     : { departments: [], relations: [], divisions: [], designations: [], departmentView: {}, employeeCount: [] },
	employeeIdReltion : null
};

export const departmentslice = createSlice({
	name     : 'department',
	initialState,
	reducers : {
		getDepartment : (state, action) =>
		{
			state.department = { initialCount: action.payload.initialCount, data: action.payload.data };
		},
		getDepartmentRedux : (state, action) =>
		{
			state.configuration = { ...state.configuration, ...action.payload };
		},
		getEmployeeIdRelation : (state, action) =>
		{
			state.employeeIdReltion = action.payload;
		}

	}
});
export const { getDepartment, getDepartmentRedux, getEmployeeIdRelation } = departmentslice.actions;
export default departmentslice.reducer;